import React from 'react';

import { Typography } from 'pixel-react';

import styles from './Terms.module.scss';
import type { TermsFooterProps } from './types';

const TermsFooter: React.FC<TermsFooterProps> = ({ handleOpenTerms }) => {
  return (
    <Typography fontSize="12px" className={styles['text-footer']}>
      By clicking Register, You have agreed that you have accepted for the{' '}
      <Typography
        className={styles['text-terms']}
        onClick={() => handleOpenTerms('terms-of-use')}
      >
        Term’s of use,
      </Typography>
      <Typography
        className={styles['text-terms']}
        onClick={() => handleOpenTerms('privacy-policy')}
      >
        Privacy Policy{' '}
      </Typography>
      <Typography className={styles['text-footer']}>and</Typography>{' '}
      <Typography
        className={styles['text-terms']}
        onClick={() => handleOpenTerms('eula')}
      >
        Eula
      </Typography>
    </Typography>
  );
};

export default TermsFooter;
